var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18V16H16.5V18H0.5ZM4.5 14C3.4 14 2.45833 13.6083 1.675 12.825C0.891667 12.0417 0.5 11.1 0.5 10V0H16.5C17.05 0 17.5208 0.195833 17.9125 0.5875C18.3042 0.979167 18.5 1.45 18.5 2V5C18.5 5.55 18.3042 6.02083 17.9125 6.4125C17.5208 6.80417 17.05 7 16.5 7H14.5V10C14.5 11.1 14.1083 12.0417 13.325 12.825C12.5417 13.6083 11.6 14 10.5 14H4.5ZM4.5 12H10.5C11.05 12 11.5208 11.8042 11.9125 11.4125C12.3042 11.0208 12.5 10.55 12.5 10V2H2.5V10C2.5 10.55 2.69583 11.0208 3.0875 11.4125C3.47917 11.8042 3.95 12 4.5 12ZM14.5 5H16.5V2H14.5V5ZM4.5 12H2.5H12.5H4.5Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole6);
export default __webpack_public_path__ + "static/media/role6.ef961b3155b58a2c418b1169bfbca828.svg";
export { ForwardRef as ReactComponent };